import useLanguage from "../../i18n/useLanguage";
import { Link } from "react-router-dom";
import { HiArrowUpRight } from "react-icons/hi2";
import ProductVisual from "./ProductVisual";

export default function ProductCard({ product }) {
  const { t, href } = useLanguage();
  return (
    <article className="group flex flex-col overflow-hidden rounded-2xl border border-white/10 bg-neutral-950 transition-colors hover:border-amber-300/50">
      <ProductVisual product={product} />
      <div className="p-6 sm:p-8 flex flex-col flex-1">
        <p className="text-sm text-amber-300 mb-2">{t(product.label)}</p>
        <h3 className="text-3xl font-bold mb-3">{product.name}</h3>
        <p className="text-gray-400 leading-relaxed mb-5">{t(product.description)}</p>
        <ul className="flex flex-wrap gap-2 mb-8" aria-label={t("Kategori produk")}>
          {product.tags.map(tag => <li key={tag} className="rounded-full border border-white/10 px-3 py-1 text-xs text-gray-300">{t(tag)}</li>)}
        </ul>
        <div className="mt-auto flex flex-wrap items-center gap-4">
          <a href={product.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-xl bg-amber-300 px-5 py-3 font-bold text-black hover:bg-amber-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-amber-300">
            {t(product.action)}<HiArrowUpRight aria-hidden="true" />
          </a>
          {product.id === "ai" && <Link to={href("/ai-photo-video")} className="text-sm text-gray-300 underline underline-offset-4 hover:text-amber-300">{t("Kenali jasa foto & video AI")}</Link>}
        </div>
      </div>
    </article>
  );
}
